import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { type EffectiveCarrier } from '../domain/Shipment'
import { ShipmentRepository } from '../infra/ShipmentRepository'

export type UpdateAssetCarrierParams = {
  shipmentUUID: string
  effectiveCarrier: EffectiveCarrier
}

export type ConfigParams = {
  signal?: AbortSignal
}

export type UpdateAssetCarrierFactoryDependencies = {
  repository: ShipmentRepository
}

export function updateAssetCarrierFactory({ repository }: UpdateAssetCarrierFactoryDependencies) {
  return async function getAgnosticShippersImpl(
    params: UpdateAssetCarrierParams,
    config?: ConfigParams
  ) {
    try {
      return await repository.updateAssetCarrierToShipment({ ...params, config })
    } catch (error) {
      const newError = new Error('Failed to update Asset carrier', { cause: error as Error })
      sentry.log(newError)
      throw newError
    }
  }
}

export function updateAssetCarrier(params: UpdateAssetCarrierParams, config?: ConfigParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const submit = updateAssetCarrierFactory({ repository })

  return submit(params, config)
}
